import { render, staticRenderFns } from "./ButtonGoogleLogin.vue?vue&type=template&id=4725eb48&scoped=true"
import script from "./ButtonGoogleLogin.vue?vue&type=script&lang=js"
export * from "./ButtonGoogleLogin.vue?vue&type=script&lang=js"
import style0 from "./ButtonGoogleLogin.vue?vue&type=style&index=0&id=4725eb48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4725eb48",
  null
  
)

export default component.exports